const textToChars = (text) => text.split('').map((c) => c.charCodeAt(0));

const applySaltToChar = (salt) => (code) =>
  textToChars(salt).reduce((a, b) => a ^ b, code); // eslint-disable-line no-bitwise

export const crypt = (salt, text) => {
  const byteHex = (n) => `0${Number(n).toString(16)}`.substr(-2);

  return text
    .split('')
    .map((c) => c.charCodeAt(0))
    .map(applySaltToChar(salt))
    .map(byteHex)
    .join('');
};

export const decrypt = (salt, encoded) => {
  const pairs = encoded.match(/.{1,2}/g) ?? [];
  return pairs
    .map((hex) => parseInt(hex, 16))
    .map(applySaltToChar(salt))
    .map((charCode) => String.fromCharCode(charCode))
    .join('');
};
